var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('top-prompt'),_c('carousel-view'),_c('home-nav'),_c('flying-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }